import { render } from "./UpdateTime.vue?vue&type=template&id=fb707d30"
import script from "./UpdateTime.vue?vue&type=script&lang=ts"
export * from "./UpdateTime.vue?vue&type=script&lang=ts"

import "./UpdateTime.vue?vue&type=style&index=0&id=fb707d30&lang=css"
script.render = render

export default script